import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, filter, map, Observable, of } from 'rxjs';

import { selectTimesheetLogs } from 'app/store/timesheet/timesheet.selector';
import { calculateUnits } from 'app/utils/helpers/helper-functions';
import dayjs from 'dayjs';
import moment from 'moment';

@Component({
  selector: 'app-timesheet-logs',
  templateUrl: './timesheet-logs.component.html',
  styleUrls: ['./timesheet-logs.component.scss'],
  standalone: false,
})
export class TimesheetLogsComponent {
  displayedColumns: string[] = [
    'date',
    'name',
    'clock_in',
    'clock_out',
    'units',
    'break_start',
    'break_end',
  ];

  timelogs$!: Observable<any>;

  constructor(private store: Store) {}

  ngOnInit() {
    this.timelogs$ = this.store.select(selectTimesheetLogs).pipe(
      filter((data): data is any[] => Array.isArray(data) && data.length > 0),
      map((logs) =>
        logs.map((log) => ({
          ...log,
          date: dayjs(log.clock_in).format('ddd, MMM DD'),
          clock_in: dayjs(log.clock_in).format('hh:mm A'),
          clock_out: log.clock_out
            ? dayjs(log.clock_out).format('hh:mm A')
            : null,
          break_start: log.break_start
            ? moment(log.break_start, 'HH:mm:ss').format('hh:mm A')
            : null,
          break_end: log.break_end
            ? moment(log.break_end, 'HH:mm:ss').format('hh:mm A')
            : null,
          units: log.clock_out
            ? calculateUnits(
                log.clock_in,
                log.clock_out,
                log.break_start,
                log.break_end
              )
            : 0,
        }))
      ),
      catchError((err) => {
        return of([]);
      })
    );
  }
}
